/**
 * Renders a 1-based rank as its ordinal ("1st", "2nd", "3rd", "4th", ... "14th", ... "21st") --
 * L8's "Your all-time" card own rank line ("All-time rank ... 14th", 923-core-context context/engineering/spark-rewards/phase-51-leaderboard-to-design.md).
 *
 * The 11/12/13 exception is checked BEFORE the last-digit switch: `%10` alone would render "11st"/
 * "12nd"/"13rd", which English never does -- every multiple-of-hundred-plus-11/12/13 (11, 12, 13, 111,
 * 112, 113, ...) always reads "-th".
 *
 * @param rank The viewer's 1-based ordinal rank, or `null` when they have no score at all in the
 *   window (`LeaderboardViewer` is the whole object, never `rank: 0`, for exactly that case).
 * @returns The ordinal string, or `"—"` for `null` -- never a fabricated "0th".
 */
export const ordinalRank = (rank: number | null): string => {
  if (rank === null) {
    return "—";
  }

  const remainder100 = rank % 100;
  if (remainder100 >= 11 && remainder100 <= 13) {
    return `${rank}th`;
  }

  switch (rank % 10) {
    case 1:
      return `${rank}st`;
    case 2:
      return `${rank}nd`;
    case 3:
      return `${rank}rd`;
    default:
      return `${rank}th`;
  }
};
